import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { AssignEntitiesEnum } from 'Common/FieldEnum';
import { SiteGroupGridContainer } from '../../containers/assignEntities/SiteGroupGridContainer';
import { UserGridContainer } from '../../containers/assignEntities/UserGridContainer';

const AssignSiteGroupToUsers = props => {
  const {
    allUsersData,
    loadingAllUsers,
    allSitesData,
    loadingSiteGroup,
    siteGroupData,
    setIsReadOnlyState,
    isReadOnly,
    onFilteredChange,
    rightSideGridReactTableRef,
    isRightGridFiltered,
    onResetPageOnDataChange,
    direction,
    resetGridPage,
  } = props;
  return (
    <Grid>
      <Grid.Row columns={2}>
        <Grid.Column width={6}>
          <Field
            component={SiteGroupGridContainer}
            name={AssignEntitiesEnum.SiteGroupGridInfo}
            {...{
              dataSource: siteGroupData,
              loadingSiteGroup,
              isLeftSideSiteGroupGrid: true,
              isRightSideUserGrid: true,
              setIsReadOnlyState,
              isReadOnly,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
        <Grid.Column width={10}>
          <Field
            component={UserGridContainer}
            name={AssignEntitiesEnum.UserGridInfo}
            {...{
              dataSource: allUsersData,
              loadingAllUsers,
              isRightSideUserGrid: true,
              allSitesData,
              setIsReadOnlyState,
              isReadOnly,
              onFilteredChange,
              rightSideGridReactTableRef,
              isRightGridFiltered,
              onResetPageOnDataChange,
              direction,
              resetGridPage,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AssignSiteGroupToUsers.propTypes = {
  allUsersData: PropTypes.array.isRequired,
  allSitesData: PropTypes.array.isRequired,
  siteGroupData: PropTypes.array.isRequired,
  resetGridPage: PropTypes.object.isRequired,
  setIsReadOnlyState: PropTypes.func,
  onFilteredChange: PropTypes.func,
  onResetPageOnDataChange: PropTypes.func,
  isReadOnly: PropTypes.bool,
  direction: PropTypes.bool,
  loadingAllUsers: PropTypes.bool,
  loadingSiteGroup: PropTypes.bool,
  rightSideGridReactTableRef: PropTypes.object,
  isRightGridFiltered: PropTypes.bool,
};

AssignSiteGroupToUsers.defaultProps = {
  loadingAllUsers: false,
  loadingSiteGroup: false,
  isReadOnly: true,
  direction: true,
  isRightGridFiltered: false,
  rightSideGridReactTableRef: null,
  setIsReadOnlyState: () => {},
  onFilteredChange: () => {},
  onResetPageOnDataChange: () => {},
};
export default AssignSiteGroupToUsers;



// WEBPACK FOOTER //
// ./src/pages/utilities/assignentities/components/assignEntities/AssignSiteGroupToUsers.js